import React, { Component, useLayoutEffect, useState } from 'react';
import Select from 'react-select';
import { ListButton, usePermissions, useResourceContext } from 'react-admin';
import { Papa } from '../common/common';

import { makeStyles } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';

import { RUN_TIME_API_ENDPOINT, CommonHeaderOption, DigitalOrderSystem, EmptyPagination } from '../common/common';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';

const BulkSendMessageCreate =(props)=> {

  const navigate = useNavigate();
  
  const [showLoader, setShowLoader] = useState(false);
  const [successMsg, setSuccessMsg] = useState(false);
  const [validationError, setValidationError] = useState(false);
  const [validationPurposeError, setValidationPurposeError] = useState(false);
  const [saveButtonDisabled, setSaveButtonDisabled] = useState(true);
  const [errorMsg, setErrorMsg] = useState(false);
  const [errorMsgText, setErrorMsgText] = useState(null);
  const [type, setType] = useState('Business');
  const [saleOffNameSapCode, setSaleOffNameSapCode] = useState([]);
  const [parsedCSVdata, setParsedCSVdata] = useState([]);
  const [unregisteredRetailers, setUnregisteredRetailers] = useState([]);
  const [pasrsedSimilarDataLength, setPasrsedSimilarDataLength] = useState(0);
  const [pasrsedDifferentDataLength, setPasrsedDifferentDataLength] = useState(0);
  const [unregisteredRetailersToggle, setUnregisteredRetailersToggle] = useState(false);
  const [saleOffList, setSaleOffList] = useState([]);
  const [messageCount, setMessageCount] = useState(0);
  const [showFileError, setShowFileError] = useState(false);
  const [originalList, setOriginalList] = useState([]);
  const [inAppPurpose,setInAppPurpose] = useState('');
  const [showModal, setShowModal] = useState(false);

  const permissions = usePermissions()

  useLayoutEffect(() => {
    // const { props, state } = this;
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = 'GET';
    fetch(`${apiUrl}/so_business_list`, options)
      .then(res => {
        return res.json();
      }).then(jsonD => {
        console.log('jsonD ===>', jsonD)
        let obj = {};
        obj.sap_order_materials = jsonD.data;
        obj.loadingShow = false;
        // console.log('obj==>', obj);
        setOriginalList(obj.sap_order_materials.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label, 'sap': item.sap_code.trim() })));
        setSaleOffNameSapCode(obj.sap_order_materials.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label, 'sap': item.sap_code.trim() })));

      });
         
}, []);

const purposeChange = (e) => {
  console.log('e >>>>>>>>>', e.target.value);
  if (e.target.value === '' || e.target.value === undefined || e.target.value === null || !e.target.value.trim().length) {
   
    setValidationError(true);
    setValidationPurposeError(true);
  } else {
    setValidationError(false);
    setValidationPurposeError(false);
  }
  setInAppPurpose(e.target.value);
};

console.log("validationPurposeError",validationPurposeError)
console.log("inAppPurpose",inAppPurpose)
console.log("saleOffList",saleOffList)


const formSave = () => {
    
  setShowLoader(true);
  setSaveButtonDisabled(false)
  const formData = {
    // title: inAppTitle.trim(),
    // description: this.state.inAppDescription.trim(),
    type: type,
    name_sap_code: saleOffList,
    purpose: inAppPurpose.trim(),

  }
  console.log('formData>>>>>>', formData);

  const apiUrl = RUN_TIME_API_ENDPOINT;
  const options = CommonHeaderOption();
  options.method = 'POST';
  options.body = JSON.stringify({ formData });

  return fetch(`${apiUrl}/send_sms_bulk_notifications`, options)
    .then(res => {
      console.log('res12...........', res)
      if (res) {
        return res.json();
      }
    }
    )
    .then(res => {
      if (res.errorMsg) {
        setShowModal(false);
        setErrorMsg(true);
        setShowLoader(false)
        setErrorMsgText(res.errorMsg);
        
        setTimeout(() => {
          setErrorMsg(false);
          setSaveButtonDisabled(true)
        }, 3000)
      } else {
        setShowLoader(false);
        setSaveButtonDisabled(true);
        setSuccessMsg(true);

        setTimeout(() => {
          setSuccessMsg(false)

        }, 2000)
        setTimeout(() => {
         navigate("/send_sms_bulk_notifications");
        }, 3000)
        console.log('res', res);
      }

    }).catch(error => {
      console.log(error);
    })

}

const handleFile = e => {
  let file = null;
  file = e.target.files[0];
  const fileType = file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length);
  if (file === null || typeof (file) === 'undefined' || file === '' || typeof (file) === undefined || fileType.toLowerCase() !== 'csv') {
    Swal.fire({
      text: 'Please choose a valid .csv file.',
      confirmButtonText: `OK`,
      icon: 'error'
    });
    file = null;
    console.log('bad file');
  } else {
    console.log([e.target.name], e.target.files[0]);
    
    setUnregisteredRetailers([]);
    setPasrsedSimilarDataLength(0);
    setPasrsedDifferentDataLength(0);

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        const checkValidHeader = Object.keys(results.data[0]);
        console.log('results======>', checkValidHeader);
        if (checkValidHeader.includes('COMPANYNAME') && checkValidHeader.includes('SAPID') && checkValidHeader.includes('DESCRIPTION')) {
          const parseddata = permissions.permissions === 'isSap' ?
            results.data.map((item, i) => ({ id: i, value: item.COMPANYNAME + '-0000' + item.SAPID, label: item.COMPANYNAME + '-0000' + item.SAPID, sap: '0000' + item.SAPID.trim(), sms_text: item.DESCRIPTION.trim() })) :
            results.data.map((item, i) => ({ id: i, value: item.COMPANYNAME + ' ' + item.SAPID, label: item.COMPANYNAME + ' ' + item.SAPID, sap: item.SAPID.trim(), sms_text: item.DESCRIPTION.trim() }));
          console.log(parseddata);
          let pasrsedSimilarData = [];
          let listWithPhoneNo = originalList.filter(e => e.sap !== e.phone);
          pasrsedSimilarData = parseddata.filter(a1 => listWithPhoneNo.some(a2 => a1.sap === a2.sap));

          if (pasrsedSimilarData && pasrsedSimilarData.length) {
            const similarArray = saleOffList !== null ? saleOffList.filter(({ sap: id1 }) =>
              !pasrsedSimilarData.some(({ sap: id2 }) => id2 === id1)) : [];
            setSaleOffList([...similarArray, ...pasrsedSimilarData]);
            setPasrsedSimilarDataLength(pasrsedSimilarData.length);

            let descriptionCount = saleOffList.reduce((acc, count) => acc + Math.ceil(count.sms_text.length / 160), 0)
            setMessageCount(descriptionCount);
          }
          const pasrsedDifferentData = parseddata.filter(a1 => pasrsedSimilarData.every(a2 => a1.sap !== a2.sap));
          if (pasrsedDifferentData && pasrsedDifferentData.length) {
            console.log(pasrsedDifferentData, pasrsedDifferentData.length)
            // this.setState({ unregisteredRetailers: [...pasrsedDifferentData], pasrsedDifferentDataLength: pasrsedDifferentData.length })
            setUnregisteredRetailers([...pasrsedDifferentData]);
            setPasrsedDifferentDataLength(pasrsedDifferentData.length);
          }
          console.log('seprated', pasrsedSimilarData, pasrsedDifferentData);
          // this.setState({ parsedCSVdata: [...parseddata] });
          setParsedCSVdata([...parseddata]);
        }
        else {
          Swal.fire({
            text: 'File headers do not match. Kindly download and refer the sample file.',
            confirmButtonText: `OK`,
            icon: 'error'
          });
        }
      }
    });
  }
};

  // cancelClick = () => {
  //   this.setState({
  //     saleOffList: [],
  //     saleOffNameSapCode: this.state.originalList,
  //     unregisteredRetailers: [],
  //     pasrsedSimilarDataLength: 0,
  //     pasrsedDifferentDataLength: 0,
  //   });
  // }


  const toggleUnregisteredRetailers = () => {
    setUnregisteredRetailersToggle(!unregisteredRetailersToggle);
  };

  const resource = useResourceContext()

    return (
      <div>
        <div className="notification-list-button"><ListButton basePath={resource} /></div>
        <div className="so-form-container">
          <div className="so-form">

            <div className="so-input">
              <label>Message Purpose<sup className="asterisk">*</sup></label>
              <input
                className="form-control"
                type="text"
                name="Purpose"
                value={inAppPurpose || ''}
                onChange={purposeChange}
              />
              {validationPurposeError &&
                <p className="so-input-error">Please enter a Purpose</p>
              }
            </div>


            {/* <input type="file" id="file" onChange={this.handleFile} /> */}

            <div>
              <div className="csv-file-upload-container target-upload-container"><label>Upload File</label>
                {/* <input type="file" accept=".csv" name="flies[]" /> */}
                <input type="file" id="file" accept=".csv" onChange={handleFile} />
                {showFileError && <p className="complaint-file-error" >Choose Valid file</p>}
                <div className="valid-file-upload">
                  <p>Instructions :</p>
                  <ul>
                    <li>Only CSV files are allowed with Comma as separator.</li>
                  </ul>
                </div>
                <div className="upload-file-format-download">
                  <p>To get upload file format. <a
                    href="https://navendor-global-production.s3-eu-west-1.amazonaws.com/fille_formats/bulk-sms-notification.csv"
                    target="_blank">Click here</a> to download</p>
                </div>
              </div>

              {
                pasrsedSimilarDataLength > 0 ||
                  pasrsedDifferentDataLength > 0 ?
                  <div className="csv-result-container">
                    <label>CSV Result</label>
                    <div className="csv-result">
                      <div>
                        <p onClick={toggleUnregisteredRetailers}>
                          {pasrsedSimilarDataLength} retailers found, {pasrsedDifferentDataLength} retailers unregistered.
                    {pasrsedDifferentDataLength > 0 ? ' Click to view unregistererd retailers' : ''}
                          {
                            pasrsedDifferentDataLength > 0 ?
                              <span className={unregisteredRetailersToggle ? `icon-arrow_down` : `icon-arrow_up`} />
                              : ''
                          }
                        </p>
                        {
                          pasrsedDifferentDataLength > 0 ?
                            <div className={unregisteredRetailersToggle ? `hide-unregistered` : `show-unregistered`}>
                              <React.Fragment>
                                {
                                 unregisteredRetailers?.length > 0 && unregisteredRetailers.map(item => (
                                    <p key={item.id}>{item.label}</p>
                                  ))
                                }
                              </React.Fragment>
                            </div>
                            : ''
                        }
                      </div>
                    </div>
                  </div> :
                  ''
              }

              {
                saleOffList !== null &&
                <div className="sms-total-cost"> Total cost: {messageCount}</div>
              }


              {
                saleOffList.length > 0 &&
                <TableContainer component={Paper}>
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        <TableCell>Sold To Id</TableCell>
                        <TableCell>Name</TableCell>
                        <TableCell>Message Count</TableCell>
                        <TableCell>Description</TableCell>
                        {/* <TableCell style={{paddingRight:"60px"}} align="right" >Department</TableCell>   */}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {
                        saleOffList.map((s, index) => {
                          return <TableRow key={index}>
                            <TableCell component="th" scope="row">
                              {s.sap}
                            </TableCell>
                            <TableCell>{s.value}</TableCell>
                            <TableCell>{s.sms_text ? Math.ceil(s.sms_text.length / 160) : ''}</TableCell>
                            <TableCell>{s.sms_text}</TableCell>
                            {/*
                            <TableCell style={{paddingRight:"114px"}} align="right">{p.Department}</TableCell>   */}
                          </TableRow>
                        })
                      }
                    </TableBody>
                  </Table>
                </TableContainer>
              }

            </div>

          </div>
          {saveButtonDisabled &&
            <div className="so-save-button">
              <button 
                // disabled={validationPurposeError || !inAppPurpose || saleOffList.length === 0}
                onClick={() => formSave()}>Save</button>
            </div>
          }

          {showLoader &&
            <div className="save-loader" />
          }
          {successMsg &&
            <div className="so-updated" >
              Successfully Created </div>
          }
          {errorMsg &&
            <div className="so-email-exist" >
              {errorMsgText}</div>
          }
        </div>
      </div>
    )
}

export default BulkSendMessageCreate;